import { useEffect, useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import { NavLink, useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { resetPassword } from "../actionCreator/commonActionCreator";
import { msgEnum } from "../config";
import "../assets/css/style.css";
import "../assets/css/auth.css";
import AuthLeftContainer from "../common/AuthLeftContainer";

const { Text } = Typography;

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [resetKey, setResetKey] = useState(null);
  const [msg, setMsg] = useState(null);

  const resetPasswordInfo = useSelector(
    (state) => state.CommonReducer.resetPasswordInfo
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setResetKey(queryParams.get("key"));
  }, []);

  useEffect(() => {
    if (resetPasswordInfo && Object.keys(resetPasswordInfo).length) {
      form.resetFields();
      if (resetPasswordInfo?.msg) {
        navigate("/signin");
      } else {
        setMsg(msgEnum.RESET_PASSWORD_MSG);
      }
    }
  }, [resetPasswordInfo]);

  const onFinish = (values) => {
    const payload = {
      key: resetKey,
      newPassword: values.password,
    };
    dispatch(resetPassword(payload));
  };

  return (
    <Container
      fluid
      className="min-vh-100 h-100 p-0 text-black position-relative roboto-regular auth overflow-x-hidden"
    >
      <Row className="min-vh-100 h-100 m-0">
        <Col lg={4} className="d-none p-0 d-lg-block">
          <AuthLeftContainer />
        </Col>
        <Col xs={12} lg={8} className="p-5">
          <div className="text-right heading12px fw-semibold">
            Don’t have an account?{" "}
            <NavLink
              to="/signup"
              className="heading12px text-theme fw-semibold"
            >
              SignUp
            </NavLink>
          </div>
          <div className="d-flex flex-column auth-card justify-content-center h-100">
            <div className="login-card">
              <div className="heading20px fw-semibold pb-4 w-100 mb20">
                Reset Password
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                {msg && (
                  <Text
                    type="success"
                    style={{ display: "block", marginBottom: 16 }}
                  >
                    {msg}
                  </Text>
                )}

                <Form.Item
                  label={
                    <label className="heading12px text-gray pb-1">
                      New Password
                    </label>
                  }
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your new password.",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="New Password*"
                    style={{ width: "100%" }}
                    className="passw"
                  />
                </Form.Item>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  className="theme-btn mt10"
                >
                  Submit
                </Button>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
